import { getToastCopy } from '../i18n/locale';

type AxiosLike = {
  code?: string;
  message?: string;
  response?: {
    status?: number;
    data?: { detail?: unknown; message?: string };
  };
};

/** Axios·fetch 오류 → 사용자용 한 줄 메시지 */
export function apiErrorMessage(err: unknown, fallback?: string): string {
  const toast = getToastCopy();
  const fb = fallback ?? toast.error.generic;
  if (!err || typeof err !== 'object') return fb;
  const ax = err as AxiosLike;

  if (ax.code === 'ERR_CANCELED') {
    return fb;
  }

  if (!ax.response) {
    const msg = ax.message || '';
    if (/network error/i.test(msg) || /timeout/i.test(msg)) {
      return toast.error.network;
    }
    return fb;
  }

  const status = ax.response.status;
  if (status === 401 || status === 403) {
    return toast.error.auth;
  }
  if (status === 503) {
    return toast.error.serverBusy;
  }

  const data = ax.response.data;
  if (data?.detail != null) {
    if (typeof data.detail === 'string' && data.detail.trim()) {
      return data.detail;
    }
    if (Array.isArray(data.detail) && data.detail.length > 0) {
      const first = data.detail[0] as { msg?: string };
      if (typeof first?.msg === 'string') return first.msg;
    }
  }
  if (typeof data?.message === 'string' && data.message.trim()) {
    return data.message;
  }

  return fb;
}
